export const CATALOGUE_DIAPOS_TAILLE_PCT_DEFAUT = 100;
export const CATALOGUE_DIAPOS_TAILLE_PCT_BORNES = {min : 50, max : 500, step : 1};

function borne_nombre (pValeur, pMin, pMax, pDefaut)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pDefaut;
    return Math.max (pMin, Math.min (pMax, tNombre));
  }

export function normalise_catalogue_diapos_taille_pct (pValeur)
  {
    return Math.round (borne_nombre (
      pValeur,
      CATALOGUE_DIAPOS_TAILLE_PCT_BORNES.min,
      CATALOGUE_DIAPOS_TAILLE_PCT_BORNES.max,
      CATALOGUE_DIAPOS_TAILLE_PCT_DEFAUT
    ));
  }
